import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const StyledEndlessCarousel = styled.div<{ c: boolean }>`
	position: relative;
	display: flex;
	overflow: hidden;
	width: 100%;
	justify-content: ${({ c }) => (c ? 'flex-start' : 'center')};
`;

export const Wrapper = styled.div<{
	gap: number;
	leftMargin: number;
	leftOffset: number;
}>`
	display: flex;
	flex-shrink: 0;
	padding-top: 4px;
	padding-bottom: 4px;
	margin-left: ${({ leftMargin }) => leftMargin + 'px'};
	gap: ${({ gap }) => gap + 'px'};
	transform: translateX(${({ leftOffset }) => -leftOffset + 'px'});
	transition: transform 0.3s;
`;

export const Button = styled.button<{ right?: boolean }>`
	position: absolute;
	top: 0;
	right: ${({ right }) => (right ? '0' : 'auto')};
	left: ${({ right }) => (right ? 'auto' : '0')};
	display: flex;
	width: 60px;
	height: 100%;
	align-items: center;
	justify-content: center;
	background: linear-gradient(90deg, var(--page-bg) 0%, transparent 100%);
	transform: ${({ right }) => (right ? 'rotate(180deg)' : '')};

	${MqTablet} {
		width: 80px;
	}
`;
